<template>
  <div class="simulate-financing simulator-view split-view fill-height">
    <v-row class="simulate-row split-view__row fill-height" no-gutters>
      <left-side-image />
      <v-col cols="12" class="simulate-panel-col split-view__panel">
        <div class="split-view__scroll">
        <div class="simulate-nav">
          <nav-bar-page />
        </div>
        <div class="simulate-content">
          <header class="simulate-hero">
            <h1 class="simulate-hero__title today-regular">
              SIMULAR FINANCIACIÓN DE PÓLIZA
            </h1>
            <p class="simulate-hero__lead today-light">
              Simula la financiación de tu póliza y descubre las mejores
              opciones para proteger tu vehículo sin comprometer tu
              presupuesto.
            </p>
          </header>

          <v-form ref="form" lazy-validation>
                <section class="simulator-fields">
                  <div class="simulator-field">
                    <label
                      class="simulator-field__label today-medium"
                      for="simulate-amount"
                    >
                      Valor de la póliza
                    </label>
                    <p class="simulator-field__hint today-light">
                      Desde $ 100.000
                    </p>
                    <currency-input
                      id="simulate-amount"
                      name="total_amount"
                      v-model.number="total_amount"
                      :options="{
                        locale: 'es-CO',
                        currency: 'COP',
                        currencyDisplay: 'hidden',
                        hideCurrencySymbolOnFocus: true,
                        hideGroupingSeparatorOnFocus: false,
                        hideNegligibleDecimalDigitsOnFocus: false,
                        autoDecimalDigits: false,
                        autoSign: false,
                        useGrouping: true,
                        accountingSign: true,
                      }"
                      @blur="newCalculateFee"
                      :rules="[rules.minValue, rules.maxValue]"
                    />
                  </div>
                  <div class="simulator-field">
                    <label
                      class="simulator-field__label today-medium"
                      for="simulate-term"
                    >
                      Plazo de financiación
                    </label>
                    <p class="simulator-field__hint today-light">
                      De {{ minFeeNumber }} a {{ maxFeeNumber }} meses
                    </p>
                    <v-select
                      id="simulate-term"
                      :items="items"
                      :rules="[(v) => !!v || 'Selecciona el campo']"
                      label="Cuotas"
                      name="fee_number"
                      autocomplete="off"
                      required
                      outlined
                      dense
                      color="primary"
                      hide-details="auto"
                      v-model="fee_number"
                      v-on:change="newCalculateFee"
                    ></v-select>
                  </div>
                </section>
              </v-form>

              <section class="simulator-result">
                <p class="simulator-result__kicker today-light">
                  Tu cuota mensual sería de
                </p>
                <p
                  class="simulator-result__amount today-medium"
                  aria-live="polite"
                >
                  {{ formatCurrency(firstFeeValue) }}
                </p>

                <dl class="simulator-meta">
                  <div class="simulator-meta__row">
                    <dt>Tasa fija mes vencido</dt>
                    <dd>{{ formatNumber(rate) }} % {{ rateType }}</dd>
                  </div>
                  <div class="simulator-meta__row">
                    <dt>Cuota inicial obligatoria</dt>
                    <dd>{{ formatCurrency(firstFeeValue) }}</dd>
                  </div>
                </dl>

                <div class="simulator-actions">
                  <v-btn
                    class="simulator-btn simulator-btn--secondary today-medium"
                    elevation="0"
                    @click="contactDialog = true"
                  >
                    Contactar asesor
                  </v-btn>
                  <v-btn
                    class="simulator-btn simulator-btn--primary today-medium"
                    elevation="0"
                    @click="dialog = !dialog"
                  >
                    Iniciar financiación
                  </v-btn>
                </div>

                <p class="simulator-disclaimer today-light">
                  *La información presentada es un cálculo aproximado basado
                  en la información suministrada y no constituye otorgamiento
                  de crédito. El estudio de la solicitud se realizará acorde
                  con las políticas de la aseguradora. Algunas condiciones
                  podrán variar sin previo aviso.
                </p>
              </section>
        </div>
        </div>
      </v-col>
    </v-row>
    <contact-data
      :dialog="contactDialog"
      @close="contactDialog = false"
    ></contact-data>
    <onboarding-modal
      :dialog="dialog"
      @close="dialog = false"
    ></onboarding-modal>
    <v-snackbar
      v-model="snackbar"
      :timeout="4000"
      bottom
      right
      role="status"
      aria-live="polite"
    >
      <div v-html="snackbarMessage"></div>
    </v-snackbar>
  </div>
</template>

<script>
import LeftSideImage from "@/components/Layouts/LeftSideImage";
import OnboardingModal from "@/components/Layouts/OnboardingModal";
import NavBarPage from "@/components/Layouts/NavBarPage";
import CurrencyInput from "@/components/SimulatorCurrencyInput";
import { api } from "@/helpers/axios";
import { locals } from "@/helpers/locals";
import ContactData from "@/views/ContactData/ContactData.vue";
import { formatCurrency, formatNumber } from "@/helpers/constants";

export default {
  name: "SimulateFinancing",
  components: {
    ContactData,
    LeftSideImage,
    NavBarPage,
    OnboardingModal,
    CurrencyInput,
  },
  data() {
    return {
      contactDialog: false,
      dialog: false,
      items: [2],
      firstFeeValue: 0,
      creditStudy: 0,
      insurance: 0,
      insuranceValue: 0,
      iva: 0,
      ivaValue: 0,
      othersFeeValue: 0,
      amortizedFee: 0,
      administration: 10000,
      fee_value: 0,
      fee_number: 2,
      typeFeeNumber: "",
      rate: 1.25,
      insuranceRate: 0,
      rateType: "",
      total_amount: 0,
      minFeeNumber: 0,
      maxFeeNumber: 0,
      minAmount: 0,
      maxAmount: 0,
      admin: 0,
      settings: [],
      rules: {
        required: (value) => !!value || "Ingresa la información",
        counterMax: (value) =>
          value.length <= 10 || "Cantidad máxima 10 digitos",
        counterMin: (value) =>
          value.length === 10 || "Cantidad minima 10 digitos",
        minValue: () =>
          this.total_amount >= this.minAmount ||
          "Monto mínimo $ " + this.formatCurrency(this.minAmount),
        maxValue: () =>
          this.total_amount <= this.maxAmount ||
          "Monto maximo $ " + this.formatCurrency(this.maxAmount),
      },
      snackbar: false,
      snackbarMessage: "",
    };
  },
  created() {
    this.settings = JSON.parse(localStorage.getItem("settings"));
    this.dataInit();
  },
  methods: {
    dataInit() {
      this.settings.credit_config.forEach((value) => {
        switch (value.key) {
          case "type_fee_number":
            this.typeFeeNumber = value.value;
            break;
          case "min_fee_number":
            this.minFeeNumber = parseInt(value.value);
            break;
          case "max_fee_number":
            this.maxFeeNumber = parseInt(value.value);
            break;
          case "min_amount":
            this.minAmount = parseInt(value.value);
            break;
          case "max_amount":
            this.maxAmount = parseInt(value.value);
            break;
          case "insurance_rate":
            this.insuranceRate = value.value;
            break;
          case "rate":
            this.rate = parseFloat(value.value);
            break;
          case "rate_type":
            this.rateType = value.value;
            break;
          case "administration":
            this.administration = parseInt(value.value);
            break;
          case "iva":
            this.iva = parseFloat(value.value);
            break;
          case "credit_study":
            this.creditStudy = parseInt(value.value);
            break;
          case "credit_insurance":
            this.insurance = parseFloat(value.value);
            break;
          default:
            console.log("NO existe: ", value.value);
        }
      });

      for (
        let i = parseInt(this.minFeeNumber);
        i <= parseInt(this.maxFeeNumber);
        i++
      ) {
        this.items.push(i);
      }
    },
    newCalculateFee() {
      this.valueFinance = parseInt(this.total_amount, 10);
      const today = new Date();
      const day = String(today.getDate()).padStart(2, '0');
      const month = String(today.getMonth() + 1).padStart(2, '0'); // Los meses empiezan en 0
      const year = today.getFullYear();
      const fechaActual = `${day}-${month}-${year}`;
      api
        .post("https://tefio-vardi.bio.credit/calcularcuota", {
          data: {
            fecha: fechaActual,
            valor: this.valueFinance,
            plazo: this.fee_number,
            tasa: this.insuranceRate,
            portafolio_id: 10040,
            idvardi: "1",
          },
        })
        .then((response) => {
          console.log("calculo sigma", response);
          this.feeValue = response.data.plan_pagos[0].cuota;
          this.amortizedFee = this.feeValue;
          this.firstFeeValue =
            this.amortizedFee +
            this.creditStudy +
            this.insurance +
            this.ivaValue;
          this.othersFeeValue = this.amortizedFee + this.admin;
        })
        .catch(
          function (error) {
            //
            console.log("errors: ", error);

            try {
              let status = error.response.status;
              if (status === 401) {
                locals.clearLocal();
                this.$router.push("/");
              }
              let errors = error.response.data.errors;
              let message = "";
              for (var [key, value] of Object.entries(errors)) {
                console.log(key + " : " + value);
                message = message + value + "<br>";
              }
              this.snackbarMessage = message;
              this.snackbar = true;
              this.loading = false;
            } catch (e) {
              console.log(e);
            }
          }.bind(this)
        );
    },
    formatCurrency: formatCurrency,
    formatNumber: formatNumber,
    validateData() {
      console.log(this.total_amount);
    },
  },
};
</script>
<style lang="scss">
.simulate-financing.simulator-view {
  height: 100%;

  .simulate-row.fill-height {
    height: 100%;
    margin: 0 !important;
  }

  .simulate-row.fill-height > .simulate-panel-col {
    box-sizing: border-box;
  }

  .simulate-nav {
    flex: 0 0 auto;
    width: 100%;
  }

  .simulate-content {
    box-sizing: border-box;
    flex: 0 0 auto;
    margin-left: auto;
    margin-right: auto;
    max-width: 720px;
    min-width: 0;
    padding: 16px 40px 40px;
    width: min(720px, 100%);
  }

  .simulate-hero {
    margin: 0 0 28px;
    text-align: center;
    width: 100%;
  }

  .simulate-hero__title {
    color: #00205b;
    font-size: 1.5rem;
    letter-spacing: 0.01em;
    line-height: 1.2;
    margin: 0;
    text-wrap: balance;
  }

  .simulate-hero__lead {
    color: rgba(0, 0, 0, 0.64);
    font-size: 0.9375rem;
    line-height: 1.45;
    margin: 12px 0 0;
    text-wrap: pretty;
  }

  .simulator-fields {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 8px 32px;
    margin-bottom: 24px;
  }

  .simulator-field__label {
    color: #00205b;
    display: block;
    font-size: 0.95rem;
    font-weight: 600;
    letter-spacing: 0.02em;
    margin: 0 0 4px;
    text-wrap: balance;
  }

  .simulator-field__hint {
    color: rgba(0, 0, 0, 0.54);
    font-size: 0.8125rem;
    line-height: 1.4;
    margin: 0 0 10px;
  }

  .simulator-result {
    background: #f8f9fc;
    border: 1px solid #e6e8ee;
    border-radius: 16px;
    padding: 20px 20px 18px;
  }

  .simulator-result__kicker {
    color: rgba(0, 0, 0, 0.64);
    font-size: 0.875rem;
    line-height: 1.4;
    margin: 0 0 4px;
    text-wrap: pretty;
  }

  .simulator-result__amount {
    color: #00205b;
    font-size: 2.25rem;
    font-variant-numeric: tabular-nums;
    letter-spacing: -0.03em;
    line-height: 1.15;
    margin: 0 0 16px;
  }

  .simulator-meta {
    margin: 0 0 20px;
  }

  .simulator-meta__row {
    align-items: baseline;
    border-bottom: 1px solid #e8e8e8;
    display: grid;
    gap: 12px;
    grid-template-columns: minmax(0, 1.1fr) minmax(0, 0.9fr);
    padding: 10px 0;

    &:last-child {
      border-bottom: none;
    }
  }

  .simulator-meta dt {
    color: rgba(0, 0, 0, 0.64);
    font-family: "HelveticaNeue-Light", "Roboto-Light", sans-serif;
    font-size: 0.875rem;
    min-width: 0;
  }

  .simulator-meta dd {
    color: #00205b;
    font-family: "HelveticaNeue-Medium", "Roboto-Medium", sans-serif;
    font-size: 0.875rem;
    font-variant-numeric: tabular-nums;
    margin: 0;
    min-width: 0;
    overflow-wrap: anywhere;
    text-align: right;
  }

  .simulator-actions {
    align-items: stretch;
    display: flex;
    gap: 12px;
  }

  .simulator-btn {
    border-radius: 10px !important;
    flex: 1;
    font-size: 0.9375rem !important;
    height: 44px !important;
    letter-spacing: 0 !important;
    min-height: 44px;
    text-transform: none !important;
    touch-action: manipulation;
    transition-duration: 150ms;
    transition-property: transform, background-color, color, box-shadow,
      border-color, opacity;
    transition-timing-function: ease-out;
  }

  .simulator-btn:active:not(.v-btn--disabled) {
    transform: scale(0.96);
  }

  .simulator-btn--primary {
    background: #00205b !important;
    box-shadow: 0 1px 2px rgba(0, 32, 91, 0.18), 0 6px 16px rgba(0, 32, 91, 0.12);
    color: #ffffff !important;
  }

  .simulator-btn--primary:hover:not(.v-btn--disabled) {
    background: #001846 !important;
  }

  .simulator-btn--secondary {
    background: #ffffff !important;
    border: 1px solid #cfd5e4 !important;
    color: #00205b !important;
  }

  .simulator-btn--secondary:hover:not(.v-btn--disabled) {
    background: #eef1f7 !important;
    border-color: #00205b !important;
  }

  .simulator-btn.v-btn--disabled {
    opacity: 0.5;
  }

  .simulator-btn:focus-visible {
    outline: 2px solid #00205b;
    outline-offset: 3px;
  }

  .simulator-disclaimer {
    color: rgba(0, 0, 0, 0.54);
    font-size: 0.75rem;
    line-height: 1.45;
    margin: 16px 0 0;
    text-wrap: pretty;
  }

  .v-input:not(.simulator-field__input) input {
    font-size: 16px !important;
    font-variant-numeric: tabular-nums;
  }

  .simulator-field__input input,
  .simulator-field__input .v-text-field__prefix {
    font-size: 1.5rem !important;
  }
}

@media (min-width: 1264px) {
  .simulate-financing.simulator-view .simulate-content {
    padding: 16px 48px 40px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .simulate-financing.simulator-view .simulator-btn {
    transition: none;
  }

  .simulate-financing.simulator-view .simulator-btn:active:not(.v-btn--disabled) {
    transform: none;
  }
}

@media (max-width: 600px) {
  .simulate-financing.simulator-view .simulate-content {
    padding: 16px 16px 32px;
  }

  .simulate-financing.simulator-view .simulate-hero__title {
    font-size: 1.35rem;
  }

  .simulate-financing.simulator-view .simulate-hero__lead {
    font-size: 0.875rem;
  }

  .simulate-financing.simulator-view .simulator-fields {
    grid-template-columns: 1fr;
    gap: 20px;
  }

  .simulate-financing.simulator-view .simulator-result {
    border-radius: 14px;
    padding: 16px;
  }

  .simulate-financing.simulator-view .simulator-result__amount {
    font-size: 1.875rem;
  }

  .simulate-financing.simulator-view .simulator-meta__row {
    gap: 2px;
    grid-template-columns: 1fr;
  }

  .simulate-financing.simulator-view .simulator-meta dd {
    text-align: left;
  }

  .simulate-financing.simulator-view .simulator-actions {
    flex-direction: column;
  }
}
</style>
